/**
 * Shared "current week" boundary for Discover → Insights. Insights are
 * static for the rest of the week they were generated in — both the
 * generation route (`src/app/api/discover/insights/route.ts`) and the
 * client-side cache (`src/@discover/insightsCache.ts`) import this so
 * freshness checks never drift out of sync with each other.
 */

/** Most recent Sunday (ISO yyyy-mm-dd) — insights are static for the rest of this week. */
export function currentWeekOf(): string {
    const now = new Date();
    const daysSinceSunday = now.getUTCDay();
    const sunday = new Date(now);
    sunday.setUTCDate(now.getUTCDate() - daysSinceSunday);
    return sunday.toISOString().slice(0, 10);
}
